import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './miras.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/260714/miras/miras-le_rockets26--{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body],
  resolveOptions: () => ({}),
}
